module.exports = __webpack_public_path__ + "077698926e91b63445ef624695583cc4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-25.png
// module id = 2136
// module chunks = 0